import { Component, OnInit } from '@angular/core';
import { ProductPackagesDataServiceProvider } from '@services/settings/product-packages.data.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { AccountServiceProvider } from '@services/user/account.service';

@Component({
	selector: 'packages-product-block',
	template: require('./product-packages-block.component.html')
})
export class PackagesProductBlockComponent implements OnInit {
	quotesDefaultIntroductionText: string;
	spinningWheelActive = false;
	companyId: number;
	quotesDefaultIntroductionId: number;

	constructor(
		private productPackagesService: ProductPackagesDataServiceProvider,
		private messageService: MessageService,
		private accountService: AccountServiceProvider
	) {}

	ngOnInit() {
		this.getQuotesDefaultIntroductionText();
		this.getCompanyId();
	}

	getCompanyId(): void {
		this.accountService.companyIdObservable.subscribe(data => {
			this.companyId = data;
		});
	}

	getQuotesDefaultIntroductionText(): void {
		this.productPackagesService.getDefaultIntroductionText().subscribe(
			(data: any) => {
				this.quotesDefaultIntroductionText =
					data.description && data.description !== '' ? data.description : '';
				this.quotesDefaultIntroductionId = data.id;
			},
			error => this.messageService.showDefaultErrorMessage(error)
		);
	}

	updateQuotesDefaultIntroductionText(): void {
		const textToSend = this.prepareTextToSend();
		if (textToSend) {
			this.spinningWheelActive = true;
			this.productPackagesService
				.updateDefaultIntroductionText(
					this.quotesDefaultIntroductionId,
					textToSend
				)
				.finally(() => {
					this.spinningWheelActive = false;
				})
				.subscribe(
					(data: any) => {
						this.quotesDefaultIntroductionText = data.description;
						this.quotesDefaultIntroductionId = data.id;
						this.messageService.showToaster('s_8', 'productsPackages');
					},
					error => this.messageService.showDefaultErrorMessage(error)
				);
		}
	}

	private prepareTextToSend(): any {
		let textToSend = JSON.parse(
			JSON.stringify(this.quotesDefaultIntroductionText)
		);

		const textToSendLength = textToSend.length;
		textToSend = textToSend.trim();

		if (textToSend.length === 0 && textToSendLength > 0) {
			this.messageService.showToaster('e_4', 'productsPackages');
			this.quotesDefaultIntroductionText = textToSend;
			return false;
		}
		return {
			description: textToSend
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./web/modern/components/packages-product/packages-product-block/product-packages-block.component.ts